"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleTypeEnum = void 0;
// eslint-disable-next-line no-shadow
var VehicleTypeEnum;
(function (VehicleTypeEnum) {
    /**
     * Internal Combustion Engine
     * petrol, diesel, gtron
     */
    VehicleTypeEnum["ICE"] = "ICE";
    /**
     * Fuel Cell Vehicle
     */
    VehicleTypeEnum["NOVCFCHV"] = "NOVC_FCHV";
    /**
     * Mild Hybrid Electric Vehicle
     */
    VehicleTypeEnum["NOVCHEV"] = "NOVC_HEV";
    /**
     * Plug-in Hybrid Electric Vehicle
     */
    VehicleTypeEnum["OVCHEV"] = "OVC_HEV";
    /**
     * Battery Plugin Electric Vehicle
     */
    VehicleTypeEnum["PEV"] = "PEV";
})(VehicleTypeEnum || (exports.VehicleTypeEnum = VehicleTypeEnum = {}));
